/**
 * Billing calendar dates — UTC day extraction to match Stripe Customer Portal.
 *
 * API fields ending in `_date` (YYYY-MM-DD) must be formatted with
 * `formatBillingDateOnly`. ISO instants for subscription period boundaries
 * should use `formatBillingDate`.
 */
import { toBcp47 } from '../hooks/useLocalizedFormat'

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/

export function formatBillingDateOnly(isoDate: string, locale: string): string {
  const match = ISO_DATE.exec(isoDate)
  if (!match) return isoDate
  const year = Number(match[1])
  const month = Number(match[2]) - 1
  const day = Number(match[3])
  const utcMidnight = new Date(Date.UTC(year, month, day))
  return utcMidnight.toLocaleDateString(toBcp47(locale), { timeZone: 'UTC' })
}

export function formatBillingDate(isoInstant: string, locale: string): string {
  const d = new Date(isoInstant)
  if (Number.isNaN(d.getTime())) return isoInstant
  const utcMidnight = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()))
  return utcMidnight.toLocaleDateString(toBcp47(locale), { timeZone: 'UTC' })
}
